import { z } from 'zod'

export enum AnalyticsPeriod {
  D7 = '7d',
  D14 = '14d',
  D30 = '30d',
}

export enum ContentAnalyticsSortField {
  REACH = 'reach',
  ENGAGEMENT_RATE = 'engagement_rate',
  AUTOMATION_REACH = 'automation_reach',
  AUTOMATION_CTR = 'automation_ctr',
  CONTACTS_CAPTURED = 'contacts_captured',
}

export enum ContentAnalyticsContentType {
  AD = 'AD',
  FEED = 'FEED',
  STORY = 'STORY',
  REELS = 'REELS',
}

export enum SortOrder {
  ASC = 'asc',
  DESC = 'desc',
}

const summarySchema = z.object({
  automations_running: z.object({
    value: z.number(),
    delta_percent: z.number(),
  }),
  automations_reach: z.object({
    value: z.number(),
    delta_percent: z.number(),
  }),
  automations_ctr: z.object({
    value: z.number(),
    delta_percent: z.number(),
  }),
})

const contentStatisticsSchema = z.object({
  igmedia_id: z.string(),
  permalink: z.string(),
  post_type: z.enum(ContentAnalyticsContentType),
  caption: z.string().nullable(),
  reach: z.number().nullable(),
  ctr: z.number().nullable(),
  engagement_rate: z.number().nullable(),
  published_at: z.iso.datetime().nullable(),
})

const automationStatisticsSchema = z.object({
  id: z.string(),
  reach: z.number().nullable(),
  ctr: z.number().nullable(),
  contacts_captured: z.number().nullable(),
})

const combinedStatisticsSchema = z.object({
  content: contentStatisticsSchema,
  automation: automationStatisticsSchema.nullable(),
})

export const AnalyticsApiSchemas = {
  getSummary: {
    query: z.object({
      period: z.enum(AnalyticsPeriod),
    }),
    response: z.object({
      data: summarySchema,
    }),
    path: z.undefined(),
  },

  getContentStatistics: {
    query: z.object({
      sort: z.enum(ContentAnalyticsSortField).optional(),
      order: z.enum(SortOrder).optional(),
      content_type: z.enum(ContentAnalyticsContentType).optional(),
      has_automation: z.boolean().optional(),
      page: z.number().optional(),
      page_size: z.number().optional(),
      period: z.enum(AnalyticsPeriod),
    }),
    response: z.object({
      period: z.enum(AnalyticsPeriod),
      total: z.number(),
      data: z.array(combinedStatisticsSchema),
    }),
    path: z.undefined(),
  },
}

export type CombinedStatistics = z.infer<typeof combinedStatisticsSchema>
export type Summary = z.infer<typeof summarySchema>
